export default {"src":"/_next/static/media/by.a2d9d034.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};